import DOM_SELECTORS from "../selectors/installmentCalculatorSelectorsMap";
import { loadExternalScript } from "../utils/loadExternalScript";

const installmentCalculatorController = () => {
    const {
        PRZELEWY24_INSTALLMENT_CONFIG,
        PRZELEWY24_INSTALLMENT_CALCULATOR_MODAL,
        PRZELEWY24_INSTALLMENT_WIDGET_MAX,
        PRZELEWY24_INSTALLMENT_WIDGET_MAX_SELECTOR
    } = DOM_SELECTORS;

    const preventInstallmentButtonSubmit = () => {
        const maxWidgetButton = document.querySelector(PRZELEWY24_INSTALLMENT_WIDGET_MAX_SELECTOR);

        if (!maxWidgetButton) {
            return;
        }

        maxWidgetButton.addEventListener('click', (e) => {
            e.preventDefault();
        });
    }

    const createInstallmentCalculator = async () => {
        const configElement = document.querySelector(PRZELEWY24_INSTALLMENT_CONFIG);
        const config = configElement?.dataset?.config;

        if (!config) {
            console.error('No P24 installment calculator config provided');
            return;
        }

        const installmentCalculatorApp = new InstallmentCalculatorApp(JSON.parse(config));
        const calculatorModal = await installmentCalculatorApp.create(PRZELEWY24_INSTALLMENT_CALCULATOR_MODAL);
        calculatorModal.render(PRZELEWY24_INSTALLMENT_CALCULATOR_MODAL);

        const maxWidget = await installmentCalculatorApp.create('max-widget');
        maxWidget.render(PRZELEWY24_INSTALLMENT_WIDGET_MAX);
    }

    const initInstallmentCalculator = async () => {
        try {
            await loadExternalScript('installment-calculator', 'https://apm.przelewy24.pl/installments/installment-calculator-app.umd.sdk.js', createInstallmentCalculator);
        } catch (error) {
            // A CDN/script failure must be loud but must never hang as an unhandled rejection; the calculator just doesn't render.
            console.error('[P24] Failed to load external script:', error);
        }
    }

    const attachEvents = () => {
        prestashop.on('updatedCart', async () => {
            await createInstallmentCalculator();
        });
        prestashop.on('updatedProduct', async () => {
            await createInstallmentCalculator();
            preventInstallmentButtonSubmit();
        });
        preventInstallmentButtonSubmit();
    }

    const init = async () => {
        await initInstallmentCalculator();
        attachEvents();
    }

    return {
        init
    }
}

export default installmentCalculatorController;
